import React, { useContext, useMemo } from 'react';
import { StatusContext } from '../context/Status';
import { getCachedStatus, getSystemName } from '../helpers';

const AuthLayout = ({ title, description, children }) => {
  const [statusState] = useContext(StatusContext);
  const status = useMemo(
    () => statusState?.status || getCachedStatus(),
    [statusState?.status]
  );
  const systemName = status.system_name || getSystemName();

  return (
    <div className='fvv-auth-split'>
      <aside className='fvv-auth-split__aside'>
        <div>
          <code>FVV CONSOLE</code>
          <h1>{systemName}</h1>
          <p>面向运营与管理的 API 网关控制台。接口能力对齐主站，交互按商务控制台独立设计。</p>
        </div>
        <code>business · navy · one-row nav</code>
      </aside>
      <div className='fvv-auth-split__main'>
        <div className='fvv-auth'>
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
